var $ = require('../../../../../../../webpack/node_modules/jquery');
var nunjucks = require('../../../../../../../webpack/node_modules/nunjucks');
require('../../../../../../../webpack/node_modules/jscroll');
redux = require('redux')
let filteredItems = [];

$(document).ready(function(){
  if(typeof projects === 'undefined') {
    return false;
  }

    nunjucks.configure('/template/dist/views', { autoescape: true });


	const itemsContainer = $('.projects-container__list-items');
	const categories = getCategories(projects);
    const initialCount = 11;
	const loadValue = 6;

	/**
	 * new redux store that manages the filter state
	 */
	const store = redux.createStore(reducer)

	/**
	 *
	 * execute on state change of redux store
	 * set active buttons
	 * and render items
	 */
	store.subscribe(() => {
		const filter = store.getState().filter;
		const page = store.getState().page;
		const hasFilter = !!filter.size
		const limit = initialCount + page * loadValue
		setActiveButtons(filter);
        setFilterClass(filter);


		filteredItems = sort(filterItems(filter), limit, hasFilter)
		items = nunjucks.render('list-item.html.twig', {data: filteredItems, filteredItems: hasFilter});
		itemsContainer.html(items);
	})

	$('.projects-container__list-categories').html(
		nunjucks.render('list-item-categories.html.twig', {categories: categories, allLabel: labels[0]['all']})
	);
	store.dispatch({ type: 'filter', activeFilter: 'all'})

	/**
	 *
	 * button click => update redux store
	 */
	$(document).on('click', '.project-category__item', function() {
		activeFilter = $(this).data('category');
		store.dispatch({ type: 'filter', activeFilter: activeFilter})
	});

	$(window).on('scroll', function() {
		if($('.projects-container__list-items').length && $('.projects-container__list-items')[0].getBoundingClientRect().bottom - window.innerHeight <  100){
			store.dispatch({ type: 'page'})
		}
	});

	/**
	 * manage state
	 *
	 * @param {{filter: Set<String|int>, page: int}} state
	 * @param {{type: string, activeFilter: <String|int>}} action
	 * @returns {{filter: Set<String|int>}}
	 */
	function reducer (state = {filter: new Set([]), page: 0}, action) {
        return {
        	filter: filterReducer(state.filter, action),
	        page: pageReducer(state.page, action)
        }
        return state;
    }

	/**
	 *
	 * @param {Set<String|int>} filter
	 * @param {Object} action
	 * @returns {*}
	 */
	function filterReducer(filter, action) {
	    if(action.type === 'filter') {
		    if(action.activeFilter === 'all') {
			    filter = new Set([])
		    } else {
			    filter.has(action.activeFilter)
				    ? filter.delete(action.activeFilter)
				    : filter.add(action.activeFilter)
			    filter = new Set([...filter])
		    }
	    }
	    return filter
    }

	/**
	 *
	 * @param {int} page
	 * @param {Object} action
	 */
	function pageReducer(page, action) {
		if(action.type == 'page') {
			page++
		} else if(action.type == 'filter') {
			page = 0
		}
		return page
    }


	/**
	 * set active classes of buttons
	 * no filter category == all
	 *
	 * @param {Set<any>}filter
	 */
	function setActiveButtons(filter) {
		$('.filter-buttons button').removeClass('active');
		if(!filter.size) {
			$('.filter-buttons .all').addClass('active');
		} else {
			$('.filter-buttons button').filter((i, button) => {
				return filter.has($(button).data('category'))
			}).addClass('active')
		}
	}


    /**
     * set filter class for list
     * no filter category == all
     *
     * @param {Set<any>}filter
     */
    function setFilterClass(filter) {
        $('.projects-container-list-items').removeClass('filtered');
        if(filter.size) {
            $('.projects-container-list-items').addClass('filtered');
        }
    }

	/**
	 * filter items by category
	 * no filter category == all
	 *
	 * @param {Set<any>}filter
	 * @returns {Array<Object>}
	 */
	function filterItems(filter) {
		if(!filter.size) {
			return projects.slice()
		}

		return projects.slice()
			.filter(project => {
				return project.categories.map(category => category.uid)
					.some(categoryUid => filter.has(categoryUid))
			})
	}

	/**
	 *
	 * @param {Array<Object>} projects
	 * @returns {Array<Object>}
	 */
	function sort (projects, limit, hasFilter = false) {
		let sortedProjects = projects.slice().sort((a,b) => a.sorting - b.sorting)
		let {lightHouses, nonLightHouses} = sortedProjects.reduce((acc, project) => {
			if(project.lighthouse && acc.lightHouses.length < 4) {
				acc.lightHouses.push(project)
			} else {
				acc.nonLightHouses.push(project)
			}
			return acc
		}, {lightHouses: [], nonLightHouses: []})

		if(hasFilter) {
			limit = limit - 2
		} else if(lightHouses.length === 1 || lightHouses.length === 3) {
			limit = limit - 1
		}

		return lightHouses.splice(0,2)
			.concat(nonLightHouses.splice(0,6))
			.concat(lightHouses)
			.concat(nonLightHouses)
			.slice(0, limit)
	}

	/**
	 *
	 * @param projects
	 * @returns {Array<Object>}
	 */
	function getCategories(projects) {
		const categories = []
		projects.map(project => project.categories)
			.flat()
			.filter(category => window.filterCategories.projects.includes(+category.uid))
			.map(category => categories[+category.uid] = category.title)
		return categories
	}
});
